import React from "react";
import Pro from "../../assets/images/pro.png";
const NoData = ({ title, img }) => {
  return (
    <div className="flex justify-center items-center flex-col gap-1">
      <img src={Pro} alt="pro" className="w-[100px] h-auto" />
      <h3 className="font-secondary font-medium text-[16px]">{title}</h3>
    </div>
  );
};

export default NoData;
